import { useState, useEffect, Dispatch, SetStateAction } from "react";
import { Text, View, StyleSheet, Dimensions } from "react-native";
import { BarCodeScanner } from "expo-barcode-scanner";
import { Button } from "../Button";
import { HStack } from "native-base";
import useQrCode from "../../screens/EnterCode/hook/useQrCode";

interface IButtonReadQrCode {
  setOpenScanner: Dispatch<SetStateAction<boolean>>;
  setValue: Dispatch<SetStateAction<string | undefined>>;
}

export function ButtonReadQrCode({
  setValue,
  setOpenScanner,
}: IButtonReadQrCode) {
  const [hasPermission, setHasPermission] = useState(false);
  const [scanned, setScanned] = useState(false);

  const handleCloseScanner = () => {
    setScanned(false);
    setOpenScanner(false);
  };


  useEffect(() => {
    const getBarCodeScannerPermissions = async () => {
      const { status } = await BarCodeScanner.requestPermissionsAsync();
      setHasPermission(status === "granted");
    };

    getBarCodeScannerPermissions();
  }, []);

  const handleBarCodeScanned = ({ type, data }: any) => {
    setScanned(true);
    setValue(data);
    handleCloseScanner();
  };

  if (hasPermission === null) {
    return <Text>Solicitando permissão de câmera</Text>;
  }
  if (hasPermission === false) {
    return <Text>Sem acesso à câmera</Text>;
  }

  return (
    <View style={{
      flex: 1,
      position: 'relative',
    }}
      >
      <BarCodeScanner
        onBarCodeScanned={scanned ? undefined : handleBarCodeScanned}
        style={{
          flex: 1,
          width: "100%",
          height: '100%',
        }}
      />

      <HStack
        position={"absolute"}
        bottom={4}
        width="100%"
        justifyContent="center"
      >
        <Button
          py={1.5}
          px={5}
          maxWidth={200}
          minWidth={200}
          label={"Fechar"}
          onPress={() => handleCloseScanner()}
        />
      </HStack>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    position: "relative",
  },
  scanner: {
    flex: 1,
    ...StyleSheet.absoluteFillObject,
  },
});
